import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Celebration from './Celebration';
import SocialShare from './SocialShare';

const { FiArrowUpRight, FiRotateCcw, FiShare2, FiCheck } = FiIcons;

function ResultScreen({ score, total, result, config, onRestart, onCtaClick }) {
  const [shared, setShared] = useState(false);

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          text: `${config.shareText} Ik had ${score}/${total} juist.`,
          url: window.location.href
        });
      } else {
        await navigator.clipboard.writeText(
          `${config.shareText} Ik had ${score}/${total} juist. ${window.location.href}`
        );
      }
      setShared(true);
    } catch {
      setShared(false);
    }
  };

  return (
    <div className="result-screen">
      <Celebration />
      <span className="section-kicker">Je blik is verbreed</span>
      <h1>{result.title}</h1>
      <p className="result-text">{result.text}</p>

      <div className="score-orbit" aria-label={`Jouw score: ${score} van ${total}`}>
        <span>Jouw score</span>
        <strong>{score} <small>/ {total}</small></strong>
      </div>

      <div className="result-actions">
        <a
          className="primary-button"
          href={config.links.stories}
          target="_blank"
          rel="noreferrer"
          onClick={() => onCtaClick('stories')}
        >
          Ontdek de echte verhalen
          <SafeIcon icon={FiArrowUpRight} aria-hidden="true" />
        </a>
        <a
          className="secondary-button"
          href={config.links.about}
          target="_blank"
          rel="noreferrer"
          onClick={() => onCtaClick('about')}
        >
          Ontdek wat gezinszorg betekent
          <SafeIcon icon={FiArrowUpRight} aria-hidden="true" />
        </a>
      </div>

      <SocialShare score={score} total={total} text={config.shareText} />

      <div className="result-tools">
        <motion.button type="button" onClick={onRestart} whileTap={{ scale: 0.97 }}>
          <SafeIcon icon={FiRotateCcw} aria-hidden="true" />
          Doe de quiz opnieuw
        </motion.button>
        <motion.button type="button" onClick={handleShare} whileTap={{ scale: 0.97 }}>
          <SafeIcon icon={shared ? FiCheck : FiShare2} aria-hidden="true" />
          {shared ? 'Link gekopieerd' : 'Deel via je telefoon'}
        </motion.button>
      </div>

      <p className="result-signoff">Gezinszorg. Da’s <strong>niegewoon.</strong></p>
    </div>
  );
}

export default ResultScreen;